import SubCategoryList from './SubCategoryList'
export default SubCategoryList
export { SubCategoryList }
